/** 与 `useThemeMode` / `THEME_STORAGE_KEY` 一致 */
export const THEME_STORAGE_KEY = 'app-theme'

export const LEGACY_THEME_KEYS = ['lip-dashboard-theme', 'app-shell-theme']

export const DEFAULT_THEME = 'dark'

export function normalizeTheme(value, fallback = DEFAULT_THEME) {
  return value === 'light' || value === 'dark' ? value : fallback
}

export function applyThemeToDocument(isDark) {
  if (typeof document === 'undefined') return
  document.documentElement.classList.toggle('dark', isDark)
  document.documentElement.style.colorScheme = isDark ? 'dark' : 'light'
}

export function migrateThemeStorage(primaryKey = THEME_STORAGE_KEY) {
  if (typeof localStorage === 'undefined') return
  if (localStorage.getItem(primaryKey)) return
  for (const key of LEGACY_THEME_KEYS) {
    const v = localStorage.getItem(key)
    if (v === 'light' || v === 'dark') {
      localStorage.setItem(primaryKey, v)
      return
    }
  }
}

/**
 * 首屏阻塞脚本：在 CSS 绘制前根据 localStorage 挂上 `html.dark`，避免浅色 :root 闪白。
 * 保持为单行，便于写入 nuxt.config `app.head.script`。
 */
export const THEME_INIT_INLINE_SCRIPT = `(function(){try{var k='${THEME_STORAGE_KEY}';function c(n){var m=document.cookie.match('(?:^|; )'+n+'=([^;]*)');return m?decodeURIComponent(m[1]):''}var t=c(k)||localStorage.getItem(k);if(t!=='light'&&t!=='dark'){var lk=${JSON.stringify(LEGACY_THEME_KEYS)};for(var i=0;i<lk.length;i++){var v=localStorage.getItem(lk[i]);if(v==='light'||v==='dark'){t=v;break;}}if(t!=='light'&&t!=='dark')t='${DEFAULT_THEME}';}var d=t==='dark';document.documentElement.classList.toggle('dark',d);document.documentElement.style.colorScheme=d?'dark':'light';}catch(e){document.documentElement.classList.add('dark');document.documentElement.style.colorScheme='dark';}})();`
